// extracted by mini-css-extract-plugin
export default {"base":"Email_base__tG0j4","header":"Email_header__2PDd+","content":"Email_content__UmnJn","to":"Email_to__-r2vk","subject":"Email_subject__J9T6N","body":"Email_body__0cd42"};